BX.Vue.component('aos__select-enter-data', {
  computed: {
    // bitrixProcessHTMLPassport: function () {
    //     let vm = this;
    //     return vm.$parent.processHTML(vm.$parent.bitrixComponent.passport);
    // },
    bitrixProcessHTMLEnterDataForm: function () {
      let vm = this;
      return vm.$parent.processHTML(vm.$parent.bitrixComponent.enterDataForm);
    },
    bitrixProcessHTMLIdeas: function () {
      let vm = this;
      return vm.$parent.processHTML(vm.$parent.bitrixComponent.ideas);
    },
    showManuallyBlock: function () {
      // return this.hideManually() ? { 'height' : 'auto', 'opacity' : 1 } : {};
      return { height: 'auto', opacity: 1 };
    },
    hideWayBlock: function () {
      return this.hideManually() ? { display: 'none' } : {};
    },
  },
  data: function () {
    let vm = this;
    return {
      attemptConnection: 0,
      bitrixProcessHTML: {
        passport: null,
        enterDataForm: null,
      },
      options: {
        date: {
          arRuMonths: vm.msg('A_AOS_SELECT_ENTER_DATA_OPTION_MONTH').split(','),
          arRuDaysByWeek: vm.msg('A_AOS_SELECT_ENTER_DATA_OPTION_WEEK').split(','),
        },
      },
      esia: {
        window: null,
        success: false,
        data: {},
        api: {
          default: 'aton:services.api.ESIA',
          dp: 'aton:services.api.DigitalProfile',
        },
        currentApi: 'default',
      },
      formLoadedInterval: false,
      services: null,
    };
  },
  methods: {
    msg: function (code) {
      return BX.aBase.msg(code);
    },
    checkField: function (obj, value) {
      return obj && typeof value === 'string' && value !== 'undefined';
    },
    setFields: function (data, isEsia, callback, checkFields = true) {
      let vm = this;

      if (
        typeof aAOSForm === 'undefined' ||
        !aAOSForm.ready ||
        typeof aAddress === 'undefined'
      ) {
        if (!vm.formLoadedInterval) {
          vm.formLoadedInterval = setInterval(function () {
            if (
              typeof aAOSForm !== 'undefined' &&
              aAOSForm.ready &&
              typeof aAddress !== 'undefined'
            ) {
              clearInterval(vm.formLoadedInterval);
              if (typeof callback === 'function') {
                callback();
              }

              vm.setFields(data, isEsia, () => {}, checkFields);
            }
          }, 10);
        }

        return false;
      }

      let aos = document.querySelector('.aos');

      if (!data) {
        return false;
      }

      let fieldsMap = {};

      let esiaFieldsDisableMap = [
        'first_name' /* Имя */,
        'middle_name' /* Фамилия */,
        'last_name' /* Отчество */,
        'series_number' /* Серия и номер паспорта */,
        'date_of_issue' /* Дата выдачи */,
        'division_code' /* Код подразделения */,
        'issued_by' /* Кем выдан */,
        'birthday' /* Дата рождения */,
        'place_of_birth' /* Место рождения */,
        'inn' /* ИНН */,
      ];

      if (vm.$parent.isEmailValidate) {
        let emailLabel = document.querySelector('.aos .field_email');

        if (emailLabel) {
          emailLabel.classList.add('__disabled-field');
          aAOSForm.hideEmailConfirmation(
            emailLabel.querySelector('[name="email"]'),
            false,
          );
        }
      }

      if (isEsia && vm.esia.currentApi !== 'dp') {
        data['seriesNumber'] = '';
        if (data['passportSeries'] && data['passportNumber']) {
          data['seriesNumber'] = data['passportSeries'] + data['passportNumber'];
        }
        fieldsMap = {
          birthday: 'birthDate',
          date_of_issue: 'passportIssueDate',
          last_name: 'lastName',
          first_name: 'firstName',
          middle_name: 'middleName',
          address: 'addressString',
          gender: 'gender',
          place_of_birth: 'placeBirth',
          series_number: 'seriesNumber',
          division_code: 'passportDivisionCode',
          issued_by: 'passportIssued',
        };
      } else {
        data['seriesNumber'] = '';
        if (data['series'] && data['number']) {
          data['seriesNumber'] = data['series'] + data['number'];
        }
        fieldsMap = {
          email: 'email',
          email_confirm: 'email',
          birthday: 'birthDate',
          country_of_birth: 'countryBirth',
          date_of_issue: 'issuedDate',
          last_name: 'lastName',
          first_name: 'firstName',
          middle_name: 'middleName',
          address: 'registrationAddressString',
          address_actual: 'actualAddressString',
          fias_id_address: 'registrationFIASCode',
          inn: 'INN',
          gender: 'gender',
          place_of_birth: 'placeBirth',
          series_number: 'seriesNumber',
          division_code: 'divisionCode',
          issued_by: 'issued',
          agent: 'partnerAgent',
          'agent_field_legal[]': 'partnerAgent',
          City: 'partnerCity',
          Partner: 'partnerName',
          'chb_address[]': 'actualAddressString',
          'iia3[]': 'IIA3',
          'chbox_q_inv[]': 'qualifiedInvestor',
          'chb_no_middlename[]': 'noMiddleName',
          'is_custom_address[]': 'isRegistrationAddressCustom',
          'is_custom_address_actual[]': 'isActualAddressCustom',
          address_actual_manual_postal_code: 'actualManualPostalCode',
          address_manual_postal_code: 'registrationManualPostalCode',
        };
      }

      if (
        vm.esia.currentApi === 'dp' &&
        (!data['countryBirth'] ||
          (data['countryBirth'] && data['countryBirth'].length === 0))
      ) {
        data['countryBirth'] = vm.msg('A_AOS_SELECT_ENTER_DATA_DEFAULT_COUNTRY');
      }

      let tempIntervals = [];

      let removeReq = (inp) => {
        inp?.removeAttribute('required');
        let placeholder = inp?.parentNode?.querySelector('.place_holder');
        if (placeholder) placeholder.innerHTML = placeholder.innerHTML.replace('*', '');
      };

      for (let i in fieldsMap) {
        let field = fieldsMap[i];
        let obj = aos.querySelector('[name="' + i + '"]');

        if (vm.checkField(obj, data[field])) {
          switch (i) {
            case 'address_actual_manual_postal_code':
              if (data[field]) {
                setTimeout(() => {
                  obj.value = data[field];
                }, 300);
              }
            case 'address_manual_postal_code':
              if (data[field]) {
                setTimeout(() => {
                  obj.value = data[field];
                }, 300);
              }
            case 'issued_by':
            case 'place_of_birth':
              obj.value = data[field];

              aAOSForm.autoGrow(obj);
              break;
            case 'last_name':
            case 'first_name':
            case 'middle_name':
              if (isEsia && i === 'middle_name' && data[field]) {
                aAOSForm.chbMiddleNameState(false);
              }
              obj.value = aAOSForm.capitalizeFirstLetter(data[field].toLowerCase());
              break;
            case 'birthday':
              if (data[field].includes('.')) {
                const [day, month, year] = data[field].split('.').map(Number);
                obj.value = new Date(year, month - 1, day)
                  .toLocaleDateString('ru-RU')
                  .slice(0, 10);
              } else {
                obj.value = new Date(data[field])
                  .toLocaleDateString('ru-RU')
                  .slice(0, 10);
              }

              break;
            case 'date_of_issue':
              obj.value = new Date(data[field]).toLocaleDateString('ru-RU').slice(0, 10);
              break;
            case 'country_of_birth':
              aAOSForm.selectCountryByName(data[field]);
              break;
            case 'gender':
              let gender = BX.aBase.find('[name="' + i + '"]');
              if (gender) {
                if ([70, 102, 1046, 1078].includes(data[field].charCodeAt())) {
                  gender[1].checked = true;
                } else {
                  gender[0].checked = true;
                }
              }
              break;
            case 'chbox_q_inv[]':
              $('[name="' + i + '"][value="' + data[field] + '"]').click();
              break;
            case 'chb_address[]':
              if (
                data?.actualAddressString.length > 0 ||
                data?.isAddressIdentical === 'true' ||
                data?.isAddressIdentical === '1'
              ) {
                let inp = $('[name="' + i + '"]');
                inp.trigger('click');
                aAOSForm.chbAddress(false);
              } else {
                aAOSForm.chbAddress(true);
              }
              break;
            case 'chb_no_middlename[]':
              if (data.noMiddleName === '1') {
                aAOSForm.middleNameState(false);
              }
              break;
            case 'address':
            case 'address_actual':
              if (!isEsia) {
                let inpAdditionalFields = BX.aBase.find(
                  '.form-cmp__additional-fields',
                  obj.closest('.form__field'),
                );
                if (inpAdditionalFields) {
                  for (let i in inpAdditionalFields) {
                    let inpAdditionalField = inpAdditionalFields[i];
                    inpAdditionalField.value = '';
                  }
                }

                obj.value = data[field];
                aAddress.changeValue(obj, function () {
                  aAddress.checkOpenSelector();
                });
                aAOSForm.autoGrow(obj);
              }
              break;
            case 'iia3[]':
              if (data[field] === 'true') {
                obj.checked = true;
              }
              break;
            case 'agent_field_legal[]':
              if (data.partnerType === '1' && data?.[field]) {
                obj.checked = true;
                aAOSForm.agentState(true);
              }
              break;
            case 'agent':
              if (data.partnerType === '1' && data?.[field]) {
                obj.value = data[field];
              }
              break;
            case 'City':
            case 'Partner':
              if (
                typeof data[field] === 'string' &&
                data[field].length > 0 &&
                data.partnerType === '0'
              ) {
                tempIntervals[i] = setInterval(function () {
                  let dropdown = $(obj).nextAll('.jq-selectbox__dropdown');
                  if (dropdown.find('ul li').length > 0) {
                    clearInterval(tempIntervals[i]);
                    dropdown.find('li:contains(' + data[field] + ')').click();
                  }
                }, 100);
              }
              break;
            case 'email':
              const isConfirmedEmail = obj
                .closest('.form__field')
                .classList.contains('__success');

              if (data[field] && !isConfirmedEmail) {
                obj.value = data[field];

                if (aAOSForm.validateEmail(data[field]) && !vm.$parent.isEmailValidate) {
                  aAOSForm.hideEmailConfirmation(obj, true);
                } else {
                  aAOSForm.hideEmailConfirmation(obj, false);
                }
              }
              break;
            case 'is_custom_address[]':
              if (data[field] === 'true' || data[field] === '1') {
                let baseFields = {
                  registrationApartment: 'c_address_flat',
                  registrationArea: 'c_address_area',
                  registrationBlock: 'c_address_block',
                  registrationCity: 'c_address_city',
                  registrationHouse: 'c_address_house',
                  registrationPostalCode: 'c_address_postal',
                  registrationRegion: 'c_address_region',
                  registrationSettlement: 'c_address_settlement',
                  registrationStreet: 'c_address_street',
                };
                let inp = $('[name="' + i + '"]');
                inp.trigger('click');

                Object.keys(baseFields).forEach((i) => {
                  let f = aos?.querySelector('[name="' + baseFields[i] + '"]');
                  if (
                    i === 'registrationStreet' &&
                    (data?.[i] === '' || data?.[i] === '-')
                  ) {
                    let noStreet = $('[name="c_address_street_chb_no[]"]');
                    setTimeout(() => {
                      noStreet.trigger('click');
                      noStreet.prop('checked', true);
                    }, 300);
                  } else if (f && data?.[i] !== '') {
                    f.value = data?.[i];
                    f.parentNode.classList.add('__success');
                  }

                  if (
                    i === 'registrationSettlement' &&
                    data?.['registrationCity'] !== ''
                  ) {
                    removeReq(f);
                  }

                  if (
                    i === 'registrationCity' &&
                    data?.['registrationSettlement'] !== ''
                  ) {
                    removeReq(f);
                  }
                });
              }
              break;
            case 'is_custom_address_actual[]':
              if (data[field] === 'true' || data[field] === '1') {
                let actualFields = {
                  actualApartment: 'c_address_actual_flat',
                  actualArea: 'c_address_actual_area',
                  actualBlock: 'c_address_actual_block',
                  actualCity: 'c_address_actual_city',
                  actualHouse: 'c_address_actual_house',
                  actualPostalCode: 'c_address_actual_postal',
                  actualRegion: 'c_address_actual_region',
                  actualSettlement: 'c_address_actual_settlement',
                  actualStreet: 'c_address_actual_street',
                };

                let inp = $('[name="' + i + '"]');
                inp.trigger('click');

                Object.keys(actualFields).forEach((i) => {
                  let f = aos?.querySelector('[name="' + actualFields[i] + '"]');
                  if (i === 'actualStreet' && (data?.[i] === '' || data?.[i] === '-')) {
                    let noStreet = $('[name="c_address_actual_street_chb_no[]"]');
                    setTimeout(() => {
                      noStreet.trigger('click');
                      noStreet.prop('checked', true);
                    }, 300);
                  } else if (f && data?.[i] !== '') {
                    f.value = data?.[i];
                    f.parentNode.classList.add('__success');
                  }

                  if (i === 'actualSettlement' && data?.['actualCity'] !== '') {
                    removeReq(f);
                  }

                  if (i === 'actualCity' && data?.['actualSettlement'] !== '') {
                    removeReq(f);
                  }
                });
              }
              break;
            default:
              obj.value = data[field];
          }

          if (isEsia && esiaFieldsDisableMap.indexOf(i) !== -1) {
            let label = obj.closest('label');
            if (label && !label.classList.contains('__disabled-field')) {
              label.classList.add('__disabled-field');
            }
          }

          let ignoreType = ['radio', 'checkbox'];
          let ignoreFields = ['City', 'Partner'];
          if (
            !ignoreType.includes(obj.getAttribute('type')) &&
            !ignoreFields.includes(obj.getAttribute('name'))
          ) {
            vm.$parent.checkEmptyField(obj);
            vm.$parent.removeError(obj);
          }
        }
      }

      if (
        data.statusAddress ===
          vm.msg('A_AOS_SELECT_ENTER_DATA_RECOGNITION_PARTIALLY_BASE') ||
        data.statusFields === vm.msg('A_AOS_SELECT_ENTER_DATA_RECOGNITION_PARTIALLY_BASE')
      ) {
        let recognitionSuccess = aos.querySelector('.form__data-recognition-success');
        recognitionSuccess.style.display = 'none';
        vm.$parent.scrollToElement('#aos', 0);
        vm.$parent.messageError(vm.msg('A_AOS_SELECT_ENTER_DATA_RECOGNITION_PARTIALLY'));
      }

      let form = aos.querySelector('.ocf__block-manual-input');
      let innDiscover = aos.querySelector('.inn-action .inn-action__discover');
      if (checkFields) {
        aAOSForm.checkRequiredFields(form);
      }
      let fieldINN = aos.querySelector('[name="inn"]');
      if (fieldINN && fieldINN.value && fieldINN.value.replace(/\D/g, '').length === 12) {
        let errorMessageINN = aos.querySelector('.message__error');
        if (errorMessageINN) {
          errorMessageINN.style.display = 'none';
        }
      } else if (aAOSForm.checkINNFields()) {
        aAOSForm.autoPasteINN = true;
        innDiscover.click();
      }
    },
    sendPassportScansAction: function (isWaitingStart, id, processingLoaderPercent) {
      let vm = this;
      let aos = document.querySelector('.aos');

      let files = BX.aBase.find('[data-bx-role="file-id"]');
      let fileIds = [];
      for (let i in files) {
        let file = files[i];
        fileIds.push(file.value);
      }

      if (fileIds.length !== 2) {
        return false;
      }

      let blockDataRecognition = aos.querySelector('.ocf__block-data-recognition');
      let blockDataRecognitionProcess = aos.querySelector(
        '.ocf__block-data-recognition-process',
      );
      let blockManualInput = aos.querySelector('.ocf__block-manual-input');
      let fieldsProcessing = aos.querySelector('.fields-processing');
      let processingLoader =
        blockDataRecognitionProcess.querySelector('.processing-loader');
      let blockRecognition = aos.querySelector('.form__recognition-block');

      if (isWaitingStart) {
        vm.$parent.scrollToElement('#aos', 0);
        vm.attemptConnection = vm.$parent.options.timeoutConnectionPR;

        if (typeof aAOSForm !== 'undefined') {
          aAOSForm.displayINN(false);
        }

        vm.selectWayBlockItemsDisableExcept('recognition');
        vm.$parent.toggleEaseOutAnimation(true, blockManualInput);
        blockRecognition.style.display = 'none';
        vm.$parent.toggleEaseOutAnimation(false, blockRecognition);
        fieldsProcessing.style.display = 'none';
        blockDataRecognitionProcess.style.display = 'block';
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      let errorCallback = function (message) {
        processingLoader.style.width = '100%';
        vm.$parent.timeoutAnimate(function () {
          vm.selectWayBlockItemsDisableExcept(vm.services);
          blockDataRecognitionProcess.style.display = 'none';
          vm.$parent.messageError(message);
          vm.$parent.toggleEaseOutAnimation(false, blockManualInput);
          blockRecognition.style.display = 'block';
          vm.$parent.toggleEaseOutAnimation(true, blockRecognition);
          fieldsProcessing.style.display = 'block';
          processingLoader.style.width = '0%';
        }, 1000);
      };

      BX.ajax
        .runComponentAction('aton:aos', 'sendPassportScans', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            isWaiting: vm.attemptConnection !== 0 ? 'Y' : 'N',
            id: id ? id : '',
            fileIds: fileIds,
          },
        })
        .then(function (request) {
          if (request.status === 'success') {
            let requestData = request.data;
            if (requestData.status === 'success') {
              processingLoader.style.width = '100%';
              vm.$parent.removeMessageError();
              vm.$parent.timeoutAnimate(function () {
                let dataRecognitionProcessing = blockDataRecognitionProcess.querySelector(
                  '.form__data-recognition-processing',
                );
                let dataRecognitionSuccess = blockDataRecognitionProcess.querySelector(
                  '.form__data-recognition-success',
                );
                if (dataRecognitionProcessing) {
                  dataRecognitionProcessing.style.display = 'none';
                }
                if (dataRecognitionSuccess) {
                  dataRecognitionSuccess.style.display = 'block';
                }
                vm.$parent.timeoutAnimate(function () {
                  if (fieldsProcessing) {
                    fieldsProcessing.style.display = 'block';
                    vm.setFields(requestData.data);
                    vm.selectWayBlockItemsDisableExcept(vm.services);
                  }
                });
              }, 1000);
            } else if (requestData.status === 'waiting') {
              setTimeout(function () {
                let delimiter = vm.$parent.options.timeoutConnectionPR;
                delimiter = delimiter === 0 ? 100 : Math.ceil(100 / delimiter);
                processingLoaderPercent += delimiter;

                if (processingLoaderPercent >= 80) {
                  processingLoaderPercent = 80;
                }
                processingLoader.style.width = processingLoaderPercent + '%';
                vm.sendPassportScansAction(
                  false,
                  requestData.data.id,
                  processingLoaderPercent,
                );
              }, 1000);
            } else if (requestData.status === 'error') {
              errorCallback(requestData.message);
            }
          } else {
            errorCallback();
          }
        })
        .catch(function () {
          errorCallback();
        });
    },
    getEsiaDataAction: function (isWaitingStart, id) {
      let vm = this;
      let aos = document.querySelector('.aos');

      if (isWaitingStart) {
        vm.$parent.blurLoader(vm.$parent.aos, true);
        vm.attemptConnection = vm.$parent.options.timeoutConnection;
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      let errorCallback = function (message) {
        message = vm.replaceEsiaText(message);
        vm.$parent.messageError(message);
        vm.$parent.scrollToElement('#aos', 0);
        vm.$parent.blurLoader(vm.$parent.aos, false);
      };

      BX.ajax
        .runAction(vm.esia.api[vm.esia.currentApi] + '.getEsiaData', {
          data: {
            isWaiting: vm.attemptConnection !== 0 ? 'Y' : 'N',
            id: id ? id : '',
            service: 'AOS',
          },
        })
        .then(function (request) {
          if (request.status === 'success') {
            let requestData = request.data;
            if (requestData.status === 'success') {
              vm.wayItemManually(true);
              let isPGU = document.createElement('input');
              isPGU.setAttribute('type', 'hidden');
              isPGU.setAttribute('name', 'isPGU');
              isPGU.setAttribute('value', '1');
              let formHiddens = aos.querySelector('.form-aos .form_cmp-hidden');
              if (formHiddens) {
                formHiddens.append(isPGU);
              }

              vm.setFields(requestData.data, true);
              vm.esia.data = requestData.data;
              vm.esia.success = true;
              vm.$parent.scrollToElement('#ocf__block-manual-input', 600);
              vm.$parent.blurLoader(vm.$parent.aos, false);
            } else if (requestData.status === 'waiting') {
              setTimeout(function () {
                vm.getEsiaDataAction(false, requestData.data.id);
              }, 1000);
            } else if (requestData.status === 'error') {
              errorCallback(requestData.message);
            }
          } else {
            errorCallback(vm.msg('A_AOS_SELECT_ENTER_DATA_ESIA_ERROR_DEFAULT'));
          }
        })
        .catch(function (a) {
          errorCallback(vm.msg('A_AOS_SELECT_ENTER_DATA_ESIA_ERROR_DEFAULT'));
        });
    },
    esiaBuildUrlAction: function () {
      let vm = this;
      let aos = document.querySelector('.aos');

      let errorCallback = function (message) {
        if (vm.esia.window) {
          vm.esia.window.close();
          vm.esia.window = null;
        }
        message = vm.replaceEsiaText(message);
        vm.$parent.messageError(message);
        vm.$parent.scrollToElement('#aos', 0);
        vm.$parent.blurLoader(vm.$parent.aos, false);
      };

      vm.$parent.blurLoader(vm.$parent.aos, true);
      vm.esia.window = window.open('about:blank', '_blank');
      BX.ajax
        .runAction(vm.esia.api[vm.esia.currentApi] + '.buildURL', {
          data: {
            service: 'AOS',
          },
        })
        .then(function (request) {
          if (request.status === 'success') {
            let requestData = request.data;
            if (requestData.status === 'success') {
              vm.esia.window.location.href = requestData.data.url;
              vm.$parent.blurLoader(vm.$parent.aos, false);
            } else if (requestData.status === 'error') {
              errorCallback(requestData.message);
            }
          } else {
            errorCallback(vm.msg('A_AOS_SELECT_ENTER_DATA_ESIA_ERROR_DEFAULT'));
          }
        })
        .catch(function () {
          errorCallback(vm.msg('A_AOS_SELECT_ENTER_DATA_ESIA_ERROR_DEFAULT'));
        });
    },
    dataRecognitionEventClick: function (e) {
      let vm = this;
      e.preventDefault();

      vm.sendPassportScansAction(true, '', 0);
    },
    selectWayBlockItemsDisableExcept: function (service) {
      let aos = document.querySelector('.aos');
      if (service !== null) {
        service =
          typeof service === 'string' && service
            ? [service]
            : typeof service === 'object' && service.length > 0
              ? service
              : [];
      }
      let wayBlockItems = BX.find('.form__way-block-item', aos);
      for (let i in wayBlockItems) {
        let wayBlockItem = wayBlockItems[i];
        if (service === null) {
          wayBlockItem.classList.add('__disabled-service');
        } else if (service.length === 0) {
          wayBlockItem.classList.remove('__disabled-service');
        } else {
          if (service.includes(wayBlockItem.getAttribute('data-service'))) {
            wayBlockItem.classList.remove('__disabled-service');
          } else {
            wayBlockItem.classList.add('__disabled-service');
          }
        }
      }
    },
    wayBlockItemsDisable: function (service) {
      let aos = document.querySelector('.aos');
      if (service !== null) {
        service =
          typeof service === 'string' && service
            ? [service]
            : typeof service === 'object' && service.length > 0
              ? service
              : [];
      }
      let wayBlockItems = BX.find('.form__way-block-item', aos);
      for (let i in wayBlockItems) {
        let wayBlockItem = wayBlockItems[i];
        if (
          service &&
          service.length > 0 &&
          !service.includes(wayBlockItem.getAttribute('data-service'))
        ) {
          wayBlockItem.classList.add('__display-none');
          // wayBlockItem.parentNode.removeChild(wayBlockItem);
        }
      }
    },
    selectWayBlockItem: function (e) {
      e.preventDefault();
      let vm = this;
      let aos = document.querySelector('.aos');

      let target = e.target;
      if (!target.classList.contains('form__way-block-item')) {
        target = target.closest('.form__way-block-item');
      }

      if (
        !target ||
        (target.classList.contains('__selected') &&
          target.getAttribute('data-service') !== 'gosuslugi')
      ) {
        return false;
      }

      let service = target.getAttribute('data-service');
      let cd = target.getAttribute('data-cd');

      let isPGU = aos.querySelector('.form-aos .form_cmp-hidden [name="isPGU"]');
      if (isPGU) {
        isPGU.value = service === 'gosuslugi' ? '1' : '0';
      }

      if (service !== 'gosuslugi' && !cd) {
        // подтверждённый email остаётся заблокированным при любом способе заполнения
        let disabledFields = BX.aBase.find(
          '.__disabled-field:not(.field_agent)' +
            (vm.$parent.isEmailValidate ? ':not(.field_email)' : ''),
          aos,
        );

        if (disabledFields) {
          for (let i in disabledFields) {
            var disabledField = disabledFields[i];
            disabledField.classList.remove('__disabled-field');
          }
        }

        if (typeof aAOSForm !== 'undefined') {
          aAOSForm.chbMiddleNameState(true);
        }
      }

      if (cd) {
        target.removeAttribute('data-cd');
      }

      // let wayBlockHr = aos.querySelector('.form__way-block__hr');
      // if (!wayBlockHr.style.display || wayBlockHr.style.display === 'none') {
      //     wayBlockHr.style.display = 'block';
      // }

      // let wayBlockItems = BX.find('.form__way-block-item', aos)
      // for (let i in wayBlockItems) {
      //     let wayBlockItem = wayBlockItems[i];
      //     if (wayBlockItem.getAttribute('data-service') === service) {
      //         wayBlockItem.classList.add('__selected', '__selected-line');
      //     } else {
      //         wayBlockItem.classList.remove('__selected', '__selected-line');
      //     }
      // }

      //let blockDataRecognitionProcess = aos.querySelector('.ocf__block-data-recognition-process');
      //blockDataRecognitionProcess.style.display = 'none';

      switch (service) {
        case 'recognition':
          vm.$parent.sendAOSBIAction('Front_AOS_EnterDataRecognition');
          vm.wayItemRecognition(true);
          vm.wayItemManually(false);
          vm.wayItemGosuslugi(false);
          vm.$parent.scrollToElement('.form__recognition-block', 600);
          break;
        case 'manually':
          vm.$parent.sendAOSBIAction('Front_AOS_EnterDataManually');
          vm.wayItemManually(true);
          vm.wayItemRecognition(false);
          vm.wayItemGosuslugi(false);
          vm.$parent.scrollToElement('#ocf__block-manual-input', 600);
          break;
        case 'gosuslugi':
          if (vm.esia.currentApi === 'dp') {
            vm.$parent.sendAOSBIAction('Front_AOS_EnterDataDigitalProfile');
          } else {
            vm.$parent.sendAOSBIAction('Front_AOS_EnterDataGosuslugi');
          }
          vm.wayItemGosuslugi(true);
          vm.wayItemRecognition(false);
          break;
      }
      vm.wayItemResizeMobile(service);
    },
    wayItemRecognition: function (state) {
      let vm = this;
      let aos = document.querySelector('.aos');
      state = state === true;
      let blockRecognition = aos.querySelector('.form__recognition-block');
      blockRecognition.style.display = 'block';
      vm.$parent.toggleEaseOutAnimation(state, blockRecognition);
    },
    wayItemManually: function (state) {
      let vm = this;
      let aos = document.querySelector('.aos');
      state = state === true;
      let manualInputBlock = aos.querySelector('.ocf__block-manual-input');
      vm.$parent.toggleEaseOutAnimation(state, manualInputBlock);
    },
    wayItemGosuslugi: function (state) {
      let vm = this;
      state = state === true;

      if (state && !vm.esia.success) {
        // vm.wayItemManually(false);
        vm.esiaBuildUrlAction();
      } else if (state && vm.esia.success) {
        // vm.wayItemManually(true);
        vm.setFields(vm.esia.data, true);
        vm.$parent.scrollToElement('#ocf__block-manual-input', 600);
      }
    },
    wayItemResizeMobile: function (service) {
      return false;
      let aos = document.querySelector('.aos');
      let manually = aos.querySelector('[data-service="manually"]');
      let gosuslugi = aos.querySelector('[data-service="gosuslugi"]');

      if (window.innerWidth > 629) {
        manually.style.width = '';
        gosuslugi.style.width = '';

        return false;
      }

      if (service === 'auto') {
        let selected = aos.querySelector('.form__way-block-item.__selected');
        if (selected) {
          service = selected.getAttribute('data-service');
        }
      }

      switch (service) {
        case 'recognition':
          manually.style.width = '80%';
          gosuslugi.style.width = '80%';
          break;
        case 'manually':
          manually.style.width = '100%';
          gosuslugi.style.width = '80%';
          break;
        case 'gosuslugi':
          manually.style.width = '100%';
          gosuslugi.style.width = '100%';
          break;
      }
    },
    replaceEsiaText: function (text) {
      let vm = this;
      let aos = document.querySelector('.aos');

      if (!text || typeof text !== 'string') {
        return '';
      }

      if (text.indexOf('#ESIA_RESEND#') !== -1) {
        text = text.replaceAll(
          '#ESIA_RESEND#',
          '<a href="#" class="esia-resend">' +
            vm.msg('A_AOS_SELECT_ENTER_DATA_ESIA_RESEND') +
            '</a>',
        );
        setTimeout(function () {
          let esiaResend = aos.querySelector('.esia-resend');
          if (esiaResend) {
            esiaResend.addEventListener('click', function (e) {
              e.preventDefault();
              let gosuslugi = aos.querySelector(['[data-service="gosuslugi"]']);
              if (gosuslugi) {
                gosuslugi.click();
              }
            });
          }
        }, 10);
      }

      return text;
    },
    formReadyCheck: function () {
      let aos = document.querySelector('.aos');
      let obj = aos.querySelector('.form-cmp__buttons button:first-child');

      if (!obj) {
        return false;
      }

      let files = BX.aBase.find('[data-bx-role="file-id"]');
      let agreementCheckboxChecked = aos.querySelector('.ocf__step form [name="check"]');
      agreementCheckboxChecked = agreementCheckboxChecked
        ? agreementCheckboxChecked.checked
        : false;

      if (files.length === 2 && agreementCheckboxChecked) {
        obj.classList.remove('disabled');
      } else {
        obj.classList.add('disabled');
      }
    },
    checkboxScanEventClick: function () {
      let vm = this;
      vm.formReadyCheck();
    },
    actions: function () {
      let vm = this;
      let aos = document.querySelector('.aos');
      let forms = BX.aBase.find('form', aos);
      if (forms) {
        for (let i in forms) {
          let form = forms[i];
          form.addEventListener('keyup', function (e) {
            if (e.keyCode === 13) {
              e.preventDefault();
            }
          });
        }
      }
      window.addEventListener(
        'resize',
        function () {
          vm.wayItemResizeMobile('auto');
        },
        true,
      );
      window.esiaCallback = function () {
        vm.getEsiaDataAction(true, '');
      };
    },
    prepareOptions: function () {
      let vm = this;
      let options = vm.$parent.content.initialData.options;
      let services = [];
      if (options.OA_USE_BEORG) {
        services.push('recognition');
      }
      if (
        (options.OA_USE_ESIA_IP_CHECK &&
          (options.OA_IS_RU_IP === true || options.OA_IS_RU_IP === null) &&
          options.OA_USE_ESIA) ||
        (!options.OA_USE_ESIA_IP_CHECK && options.OA_USE_ESIA)
      ) {
        services.push('gosuslugi');
      }
      if (options.OA_USE_MANUAL) {
        services.push('manually');
      }
      if (options.OA_USE_DIGITAL_PROFILE) {
        vm.esia.currentApi = 'dp';
      }
      if (services.length === 0) {
        services = null;
      }
      vm.services = services;
      if (options.OA_USE_DISPLAY_NONE) {
        vm.wayBlockItemsDisable(vm.services);
      }
      vm.selectWayBlockItemsDisableExcept(vm.services);
    },
    setClientData: function () {
      let vm = this;
      let aos = document.querySelector('.aos');

      if (Object.keys(vm.$parent.clientData).length > 0) {
        vm.setFields(
          vm.$parent.clientData,
          false,
          function () {
            setTimeout(function () {
              let manually = aos?.querySelector('[data-service=manually]');

              if (manually) {
                manually.setAttribute('data-cd', '1');
                manually.click();
              }

              if (vm.$parent.stepData.pdCheckError) {
                vm.$parent.messageError(vm.msg('A_AOS_SELECT_ENTER_DATA_PD_CHECK_ERROR'));
              }
            }, 150);
          },
          false,
        );
      }
    },
    hideManually: function () {
      return (
        this.services && this.services.length === 1 && this.services.includes('manually')
      );
    },
  },
  mounted: function () {
    let vm = this;
    vm.$parent.titleClass = 'ocf__section-title__select-enter-data';
    vm.$parent.title = vm.msg('A_AOS_SECTION_TITLE_PERSONAL_DATA');
    vm.actions();
    vm.prepareOptions();

    vm.setClientData();
    vm.$parent.removeMessageError();
    vm.$parent.scrollToElement('._aos', 0);

    if (vm.$parent.changeInfoPopup?.style?.display === 'flex') {
      vm.$parent.changeInfoPopup.querySelector('.close-popup').click();
      vm.$parent.changeInfoPopup.remove();
      vm.$parent.changeInfoPopup = null;
    }
  },
  template: `
          <div class="aos__select-enter-data">
          <div class="ocf__section ocf__section-visible">
            <div class="ocf__block ocf__block-data-recognition-process">
              <div class="form__data-recognition form__data-recognition-success">
                <span class="recognition-text">{{ msg('A_AOS_SELECT_ENTER_DATA_RECOGNITION_SUCCESS') }}</span>
              </div>
              <div class="form__data-recognition form__data-recognition-processing">
                <span class="processing-loader"></span>
                <span class="processing-text">
                      {{ msg('A_AOS_SELECT_ENTER_DATA_RECOGNITION_PROCESSING') }}
                    </span>
              </div>
            </div>
            <div class="ocf__block ocf__block-data-recognition">
              <form class="form">
                <div class="form__note-block">
                  <div class="form__note-block__item" v-text="msg('A_AOS_SELECT_ENTER_DATA_NOTE_BLOCK')"></div>
                </div>
                <div class="form__note-block -desc">
                  <div class="form__note-block__item" v-if="this.$parent.content.initialData.options['OA_USE_DESC_CUSTOM']"
                       v-html="this.$parent.content.initialData.options['OA_DESC_CUSTOM']"/>
                </div>
                <div class="form__way-block" v-bind:style="hideWayBlock">
                  <div class="form__way-block-item" data-service="gosuslugi" v-on:click="selectWayBlockItem">
                    <div class="form__way-block-item__icon"></div>
                    <div class="form__way-block-item__text"
                         v-html="msg('A_AOS_SELECT_ENTER_DATA_SECTION_WAY_GOSUSLUGI')"></div>
                  </div>
                </div>
                <div class="form__way-block__hr"></div>
                <div class="form__recognition-block">
                  <div id="note-recognition" class="ocf__section-note"
                       v-html="msg('A_AOS_SELECT_ENTER_DATA_RECOGNITION_NOTE')"></div>
                  <!--                      <div v-if="bitrixProcessHTMLPassport" v-html="bitrixProcessHTMLPassport"></div>-->
                  <div class="form__chbox">
                    <label for="chb-recognition" class="l_checkbox"
                           v-if="this.$parent.content.selectEnterData.checkbox">
                      <input v-on:click="checkboxScanEventClick" id="chb-recognition" name="check" value="on"
                             type="checkbox"
                             data-required="true" class="form__chbox-input js-required-checked"><span
                        v-html="this.$parent.content.selectEnterData.checkbox"></span>
                    </label>
                  </div>
                  <div class="form-cmp__buttons __left">
                    <button type="button" v-on:click="dataRecognitionEventClick"
                            class="button button-recognize dark-blue disabled">
                      {{ msg('A_AOS_SELECT_ENTER_DATA_BUTTON_IDENTIFY') }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="ocf__block ocf__block-manual-input" id="ocf__block-manual-input"
                 v-bind:style="showManuallyBlock">
              <div v-if="bitrixProcessHTMLEnterDataForm" v-html="bitrixProcessHTMLEnterDataForm"></div>
            </div>
            <div class="ocf__block ocf__block-success-send">
              <form class="form">
                <div v-html="msg('A_AOS_SELECT_ENTER_DATA_SUCCESS_MESSAGE')"
                     class="form__success-send__text">
                </div>
              </form>
            </div>
            <div class="ocf__block ocf__block-error-send">
              <form class="form">
                <div class="ocf__info">
                  <div class="ocf__info-block">
                    <div class="ocf__info-desc"
                         v-html="$parent.processEndText ? $parent.processEndText : msg('A_AOS_SELECT_ENTER_DATA_PROCESS_END')"/>
                  </div>
                </div>
              </form>
            </div>
          </div>
          </div>
        `,
});
